export default __webpack_public_path__ + "static/icon-34-5-12777ff8cee2fe787865db64fe9b63f5.png";